/*** Created by qfintern on 18/04/2018  ***/

import { Login } from './api-login';
import { Passwords } from './api-passwords';
import { Users } from './api-users';
import { Pharmacies } from './api-pharmacies';
import { Companies } from './api-companies';
import { Orders } from './api-orders';
import { Address } from './api-address-location';
import { Patients } from './api-patients';

export const Api = Object.freeze({
    Login,
    Passwords,
    Users,
    Pharmacies,
    Companies,
    Orders,
    Address,
    Patients
});



// WEBPACK FOOTER //
// ./src/customModules/Common/rest-api/api-exports.js